

import { Switch } from '@mui/material';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { fetchAccounts } from 'slices/accountSlice';
import { accountsSelector } from 'slices/accountSlice';
import { appointmentsSelector } from 'slices/appointmentSlice';
import moment from "moment";
import { fetchDepartments } from 'slices/departmentsSlice';
import { departmentsSelector } from 'slices/departmentsSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { facilitiesSelector } from 'slices/facilitiesSlice';
import { hospitalSelector } from 'slices/hospitalSlice';
import { fetchLanguages } from 'slices/languageSlice';
import { languageSelector } from 'slices/languageSlice';
import { fetchTypes } from 'slices/typeSlice';
import { typesSelector } from 'slices/typeSlice';
import { Select } from 'components/common/Select';
import { selectCustomStyles } from 'components/common/Select';
import SelectInterperter from 'components/common/ListInterperter';
import { useState } from 'react';

const serviceOption = [
    { value: 'in_person', label: 'In Person' },
    { value: 'otp_preschedule', label: 'OTP Preschedule' },
    { value: 'vide_remote_interpretation', label: 'Video Remote Interpretation' },
    { value: 'opi_on_demand', label: 'OPI On Demand' },
]

const videoPlatformOptions = [
    { value: 'algovi', label: 'Algovi' },
    { value: 'external', label: 'External' },
]

const ListInterpreters = ({ item, handleSubmit, watch, onClose, control, dispatch, ConfirmData, popupType , language_id, isEditMode}) => {
    const { error, loader } = useSelector(appointmentsSelector);
    const [selectedInterpreters, setSelectedInterpreters] = useState(null);
    const filters = {
        us_based: watch("us_based"),
        non_us_based: watch("non_us_based"),
        english_to_target: watch("english_to_target"),
        spanish_to_target: watch("spanish_to_target"),
        court_certified: watch("court_certified"),
        medical_certified: watch("medical_certified"),
    };

    return (
        <>
        <div className="interpreter-list-container">
            <div className="d-flex justify-content-between align-items-center">
                <h2>Selected Vendors</h2>
                
                <div className="d-flex align-items-center gap-2">
                    <p className="mb-0 text-nowrap">Exclude Vendor</p>
                    <Controller
                        name="exclude_interpreter"
                        control={control}
                        defaultValue={item?.exclude_interpreter || false}
                        render={({ field }) => (
                            <Switch
                                checked={field.value}
                                onChange={(e) => field.onChange(e.target.checked)}
                                color="primary"
                                disabled={isEditMode}
                            />
                        )}
                    />
                </div>
            </div>

                    <SelectInterperter
                        setInterpreter={setSelectedInterpreters}
                        exclude_interpreter={watch("exclude_interpreter")}
                        autoSelectAll={true}
                        language_id={language_id}
                        filters={filters}
                    />
                    </div>
        </>
    )
};



export default ListInterpreters